// removed by extract-text-webpack-plugin
module.exports = {"BannerImage":"src-components-Destination-BannerImage----BannerImage-module---BannerImage---adhwF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Destination/BannerImage/BannerImage.module.scss
// module id = 723
// module chunks = 168707334958949